/**
 * BrandBar Component
 * Fixed header spanning full width, always visible above all content
 * Contains TRUVEX text centered
 */

import React from 'react';

function BrandBar() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 'var(--brandbar-height)',
        backgroundColor: '#17052B',
        borderBottom: '1px solid rgba(255, 250, 234, 0.08)',
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* TRUVEX Text - Centered */}
      <span
        style={{
          fontFamily: 'Bellefair, serif',
          fontWeight: 400,
          fontSize: '20px',
          color: '#FFFAEA',
          letterSpacing: '1px',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          textRendering: 'optimizeLegibility',
        }}
      >
        TRUVEX
      </span>
    </div>
  );
}

export default BrandBar;
